<template>
  <v-menu
      offset-y
      :close-on-content-click="false"
      :value="isOpen"
      @input="handleOpen"
      @update:return-value="handleOpen"
      :open-on-focus="false"
      :open-on-click="true"
      :top="true">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :class='activatorClass'
          v-bind="attrs"
          v-on="on"
          small
          elevation=0
          >
          {{selectedText}}
        </v-btn>
      </template>
      <template v-slot:default>
        <v-list class='voice-list'>
          <v-list-item 
            v-for="(voice) in voices"
            :key="voice.voiceURI"
            @click="createInputHandler(voice)(voice)"
          >
            <v-list-item-title>
              {{ `${voice.lang}: ${voice.name}`}}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </template>
    </v-menu>
</template>


<script>
import { computed, defineComponent, ref } from 'vue'
import { getCurrentInstance } from 'vue'

export default defineComponent({
  props:{
    open: {},
    voices: {
      type: Array
    },
    activatorClass: {
      type: String
    },
    voice: {}
  },
  setup(props, context){
    const root = getCurrentInstance();
    const vuetify = root.proxy.$vuetify;
    const open = ref(false);

    const handleInput = (voice)=>{
      handleOpen(false);
      context.emit('voice-changed', voice)
    }

    const handleOpen = (newVal)=>{
      open.value = !!newVal;
      context.emit('menu-opened', !!newVal);
    }

    const createInputHandler = (voice)=>{
      return handleInput.bind(this, voice);
    }

    const isOpen = computed(()=>{
      return props.open !== undefined  
        ? props.open
        : open.value
    })

    const selectedText = computed(()=>{
      return vuetify.breakpoint.mdAndUp 
        ? (props.voice && props.voice.name || '') 
        : (props.voice && props.voice.lang || '')
    })

    return {
      createInputHandler,
      selectedText,
      handleOpen,
      isOpen
    }
  }
})

</script>

<style lang="scss" scoped>
  .voice-list {
    max-height: 400px;
    max-height: 85vh;
    overflow-y: auto;
  }
</style>
